import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../core/services/data.service';
import { Router } from '@angular/router';
import { NativeIntegrationService } from 'src/core/services/native-integration.service';
import { TermsService } from 'src/core/services/term.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
})
export class TermsOfServiceComponent implements OnInit {
  tosScrolled = false;
  termsOfService!: any;

  constructor(
    private native: NativeIntegrationService,
    private dataService: DataService,
    private termsService: TermsService,
    private router: Router
  ) {}

  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    console.log('[TERMS]: Init');
    // Datenabruf
    const legalsSub = this.dataService.legals$.subscribe((data) => {
      this.termsOfService = data;
    });
    this.subscriptions.push(legalsSub);

    const translationsSub = this.dataService.translationsLoaded$.subscribe(
      (loaded) => {
        if (loaded) {
          console.log('[TERMS] translations loaded');
        }
      }
    );
    this.subscriptions.push(translationsSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // Speichert Datum wann AGB akzeptiert wurden im local storage und navigiert weiter zum Pack Download
  termsAccepted(): void {
    if (!this.termsOfService?.version) {
      return;
    }
    this.termsService.acceptTerms(this.termsOfService.version);
  }

  onScroll(event: any): void {
    // Checkt ob AGB komplett angesehen wurde und schaltet Akzeptieren Button frei
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight - 80
    ) {
      this.tosScrolled = true;
    }
  }
}
